export default {
  inject: ['colorRoot'],

  methods: {
    __confirm(val) {
      // 简易记录最近N个颜色
      const str = localStorage.getItem('LOCAL_COLOR_KEY')
      const list = str ? str.split(',') : []
      list.unshift(val)
      localStorage.setItem('LOCAL_COLOR_KEY', list.join(','))
      this.colorRoot._change(val)
      this.__close()
    },

    __close() {
      this.colorRoot.hideDialog()
    },
  },
}
